// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2Z_nz","label":"SetPasswdForm_label__2rTzr"};